import React, {Fragment} from 'react';
import articleStep from "./steps/article";
import checklistStep from "./steps/checklist";
import completeStep from "./steps/complete";
import customHtmlStep from "./steps/custom-html";
import customJsonStep from "./steps/custom-json";
import beaker2Step from "./steps/beaker2";
import dragAndDropStep from "./steps/drag-and-drop";
import filteringStep from "./steps/filtering";
import galleryStep from "./steps/gallery";
import groceryStep from "./steps/grocery-checklist";
import leadGenStep from "./steps/lead-gen";
import listicleStep from "./steps/listicle";
import mediaUploadStep from './steps/media-upload'
import memoryMatchStep from "./steps/memory-match";
import personalityQuizStep from "./steps/personality-quiz";
import pinterestStep from "./steps/pinterest";
import pollStep from "./steps/poll";
import puzzleStep from "./steps/puzzle";
import receiptVerificationStep from "./steps/receipt-verification";
import referralStep from "./steps/referral";
import reviewStep from "./steps/review";
import spotTheDifferenceStep from "./steps/spot-the-difference";
import storeFinderStep from "./steps/store-finder";
import textTriviaStep from "./steps/text-trivia";
import ugcStep from "./steps/ugc";
import videoStep from "./steps/video";
import AutoManagedAccordion from "hoc/IndexedSubSectionWrapper";
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {
    NextButtonLinkTypeToolTip,
    NextButtonTextToolTip,
    RelatedBreakToolTip,
    RelatedBreakUrlToolTip,
    SharingOnToolTip,
    ShowNextButtonToolTip,
    ShowSkipLinkToolTip,
    SkipLinkLinkTypeToolTip,
    SkipLinkTextToolTip
} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {isNoU, makeBreakStepSectionKey} from "utils/DBUtils";
import * as ResourceApi from 'api/resources';
import {createButtonSectionFactory} from "hoc/CreateButtonSection";
import includes from 'lodash/includes';
import {isBreakInHub} from "../../../../utils/DBUtils";
import {isMultiStepBreak, isNewLayout} from 'utils/break-utils';

const stepsWithoutRelatedBreaks = [
    'CustomHtmlStep',
    'CustomJsonStep',
    'Beaker2Step',
    'LeadGenStep',
    'StoreFinderStep',
    'GroceryStep',
    'ReviewStep'
];

const StepHeader = (props) => {
    console.log(props)
    return (
        <React.Fragment>
          <FormattedMessage id={`editbreak.steps.${props.step.type.toLowerCase()}.heading.abv`}/>, {props.step.internalLabel}
        </React.Fragment>
      );
}

const makeStepSubHeader = (subKey, extra) => (props) => (
  <Fragment>
    <FormattedMessage id={`editbreak.steps.${props.step.type.toLowerCase()}.innerHeading`}/>
    <FormattedMessage id={subKey}/>
    { extra && extra }
  </Fragment>
);

export default {
    getUniqueSectionKey: (step) => makeBreakStepSectionKey(step.currentResource.id),

    props: {
        getInnerHeader: (props) => {
            return (
                <Fragment>
                    <FormattedMessage id={`editbreak.steps.${props.step.type.toLowerCase()}.heading`}/>
                    &nbsp;- { props.step.rewardForCompleting } pts
                </Fragment>
            )
        },
        getClassName: (step) => `${step.type.toLowerCase()}-accordion`,
    },

    resource: true,
    collection: true,
    name: "steps",

    fields: [
        articleStep,
        checklistStep,
        completeStep,
        customHtmlStep,
        customJsonStep,
        beaker2Step,
        dragAndDropStep,
        filteringStep,
        galleryStep,
        groceryStep,
        leadGenStep,
        listicleStep,
        mediaUploadStep,
        memoryMatchStep,
        personalityQuizStep,
        pinterestStep,
        pollStep,
        puzzleStep,
        receiptVerificationStep,
        referralStep,
        reviewStep,
        spotTheDifferenceStep,
        storeFinderStep,
        textTriviaStep,
        ugcStep,
        videoStep,
        // {
        //     type: 'image',
        //     name: 'backgroundImageId',
        //     idFor: 'backgroundImage',
        //     showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored' && isNewLayout(proxy.currentBaseResource)),
        //     props: {
        //         labelKey: 'editbreak.steps.backgroundImage',
        //         imageType: 'stepBackgroundImage'
        //     }
        // },
        // {
        //     type: 'color',
        //     name: 'backgroundColor',
        //     showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored' && isNewLayout(proxy.currentBaseResource)),
        //     props: {
        //         labelKey: 'editbreak.steps.backgroundColor',
        //     }
        // },

        {
            key: "stepRelatedBreaksAndComments",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,
            showSection: proxy => {
                // always show this this on editorial
                // on sponsored, only show it for complete step
                //
                if (proxy.currentBaseResource.sponsoredType === "editorial") {
                    return true
                }
                
                return proxy.currentResource.resourceId.type === ResourceApi.Types.CompleteStep

                // old logic
                //return !includes(stepsWithoutRelatedBreaks, proxy.currentResource.resourceId.type) && !isBreakInHub(proxy.currentBaseResource)

            },

            props: {
                innerHeader: true,
                getInnerHeader: makeStepSubHeader('editbreak.steps.related_breaks.headline')
            },

            fields: [
                {
                    type: 'relatedBreakEditor',
                    props: {

                    }
                },
                {
                  name: 'relatedBreaks',
                  subSection: true,
                  resource: true,
                  behavior: "sectionPerElement",
                  sectionWrapper: IndexedSubSectionWrapper,
                  deletable: true,
                  sortable: true,
                  sortableName: "breakStepRelatedBreaksOrder",
                  toggleSortLabelKey: 'editbreak.steps.related_breaks.reorder_toggle',
                  resourceType: ResourceApi.Types.RelatedBreak,
                  canCreate: (formProxy) => (!formProxy.parentCurrentResource.relatedBreaks || (formProxy.parentCurrentResource.relatedBreaks && formProxy.parentCurrentResource.relatedBreaks.length < 9)),
                  canDelete: (formProxy) => (formProxy.parentCurrentResource.relatedBreaks.length > 3),
                  props: {
                    headerKey: 'editbreak.steps.related_breaks.header',
                      getCustomSectionHeader: (item, sectionIndex) => {
                        let text = "Related Link " + (sectionIndex+1);
                        if (!isNoU(item.relatedBreakText)) {
                            text += ": " + item.relatedBreakText;
                        }
                        return text;
                      }
                  },
                  footerContent: createButtonSectionFactory( ResourceApi.Types.RelatedBreak),
                  fields: [
                    {
                        type: 'textarea',
                        name: 'relatedBreakText',
                        required: true,
                        props: {
                            labelKey: 'editbreak.steps.related_breaks.relatedBreak',
                            helpContent: <RelatedBreakToolTip/>,
                            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.relatedBreak'}/></IntlProvider>
                        }
                    },
                    {
                        type: 'text',
                        name: 'relatedBreakLink',
                        required: true,
                        props: {
                            labelKey: 'editbreak.steps.related_breaks.relatedBreakLink',
                            helpContent: <RelatedBreakUrlToolTip/>,
                            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'editbreak.steps.related_breaks.relatedBreakLink'}/></IntlProvider>,
                            validationRules: [
                                {
                                    type: 'PermalinkFormat'
                                }
                            ]
                        },

                    }
                  ]
                }
            ]
        },
        {
            key: "stepNextButton",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,

            showSection: (proxy) => {
                // console.log(proxy.currentBaseResource)
                // return (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1)
                // return (proxy.currentBaseResource.layout !== "VERTICAL_SCROLL")
                return true
            },

            props: {
                innerHeader: true,
                getInnerHeader: makeStepSubHeader('editbreak.steps.nextButton.headline')
              },

            fields: [
                {
                    conditionalSection: true,
                    name: 'showNextBtn',
                    required: false,
                    props: {
                        labelKey: 'editbreak.steps.nextButton.showNextButton',
                        helpContent: proxy => <ShowNextButtonToolTip stepType={proxy.currentResource.type.toLowerCase()}/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.showNextButton'}/></IntlProvider>
                    },

                    fields: [
                        {
                            type: 'text',
                            name: 'buttonText',
                            required: false,
                            props: {
                                labelKey: 'editbreak.steps.nextButton.buttonText',
                                placeholder: 'editbreak.steps.nextButton.buttonText.placeholder',
                                helpContent: <NextButtonTextToolTip/>,
                                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.nextButtonText'}/></IntlProvider>
                            }
                        },
                        {
                            type: 'radio',
                            name: 'buttonType',
                            required: false,
                            showField: (proxy) => {
                                return (proxy.currentBaseResource.layout !== "VERTICAL_SCROLL")
                            },
                            props: {
                                labelKey: 'editbreak.steps.nextButton.linkType',
                                helpContent: <NextButtonLinkTypeToolTip/>,
                                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.nextButtonLinkType'}/></IntlProvider>,
                                options: [
                                    {
                                        value: "BUTTON",
                                        textKey: 'editbreak.steps.nextButton.linkType.button'
                                    },
                                    {
                                        value: "LINK",
                                        textKey: 'editbreak.steps.nextButton.linkType.hyperlink'
                                    }
                                ]
                            }
                        },
                        {
                          type: 'yesnoradio',
                          name: 'hasNextDelay',
                          required: true,
                          showField: (proxy) => (proxy.currentResource.type === 'VIDEO'),
                          props: {
                            labelKey: 'editbreak.steps.next_button.has_next_delay'
                          }
                        }
                    ]
                },
                {
                    conditionalSection: true,
                    name: 'showSkipButton',
                    required: false,
                    showField: true,
                    props: {
                        labelKey: 'editbreak.steps.skipButton.showSkipButton',
                        helpContent: proxy => <ShowSkipLinkToolTip stepType={proxy.currentResource.type.toLowerCase()}/>,
                        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.showSkipLink'}/></IntlProvider>
                    },

                    fields: [
                        {
                            type: 'text',
                            name: 'skipButtonText',
                            required: false,
                            props: {
                                labelKey: 'editbreak.steps.skipButton.buttonText',
                                helpContent: <SkipLinkTextToolTip/>,
                                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.skipLinkText'}/></IntlProvider>
                            }
                        },
                        {
                            type: 'radio',
                            name: 'skipButtonType',
                            required: false,
                            showField: (proxy) => {
                                return (proxy.currentBaseResource.layout !== "VERTICAL_SCROLL")
                            },
                            props: {
                                labelKey: 'editbreak.steps.nextButton.linkType',
                                helpContent: <SkipLinkLinkTypeToolTip/>,
                                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.skipLinkLinkType'}/></IntlProvider>,
                                options: [
                                    {
                                        value: "BUTTON",
                                        textKey: 'editbreak.steps.nextButton.linkType.button'
                                    },
                                    {
                                        value: "LINK",
                                        textKey: 'editbreak.steps.nextButton.linkType.hyperlink'
                                    }
                                ]
                            }
                        }
                    ]
                }, // end show skip button
                {
                  type: 'textarea',
                  name: 'footerHtml',
                  required: false,
                  props: {
                    labelKey: 'editbreak.steps.next_button.footer_html'
                  }
                }
            ]
        },
        {
            key: "stepSharing",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,
            showSection: true,

            props: {
                innerHeader: true,
                getInnerHeader: makeStepSubHeader('editbreak.steps.sharing.headline')
            },

            fields: [
                {
                    conditionalSection: true,
                    name: 'socialShareOn',
                    required: true,

                    props: {
                        labelKey: 'editbreak.steps.sharing.sharing_on',
                        helpContent: proxy => <SharingOnToolTip stepType={proxy.currentResource.type.toLowerCase()}/>,
                    },

                    fields: [
                        {
                            type: 'yesnoradio',
                            name: "shareMap.EMAIL.enabled",

                            props: {
                                labelKey: 'editbreak.steps.sharing.email'
                            }
                        },
                        {
                            type: "text",
                            name: "shareEmailSubject",
                            showField: (proxy) => {
                            //   console.log('', proxy.currentResource)
                                return proxy.currentResource.shareMap.EMAIL.enabled
                            },
                            required: false,
                            props: {
                              labelKey: "Email Share - Subject line",
                            },
                        },
                        {
                            type: "text",
                            name: "shareEmailBody",
                            showField: (proxy) => {
                            //   console.log('', proxy.currentResource)
                                return proxy.currentResource.shareMap.EMAIL.enabled
                            },
                            required: false,
                            props: {
                              labelKey: "Email Share - Body",
                            },
                        },
              
                        {
                            type: 'yesnoradio',
                            name: "copyShare",

                            props: {
                                labelKey: 'editbreak.steps.sharing.copy'
                            }
                        },

                        {
                            type: 'yesnoradio',
                            name: "downloadShare",

                            props: {
                                labelKey: 'editbreak.steps.sharing.download'
                            }
                        },

                        {
                            type: 'yesnoradio',
                            name: "shareMap.FACEBOOK.enabled",

                            props: {
                                labelKey: 'editbreak.steps.sharing.facebook'
                            }
                        },

                        {
                            type: 'yesnoradio',
                            name: "shareMap.PINTEREST.enabled",

                            props: {
                                labelKey: 'editbreak.steps.sharing.pinterest'
                            }
                        },

                        {
                            type: 'yesnoradio',
                            name: "shareMap.TWITTER.enabled",

                            props: {
                                labelKey: 'editbreak.steps.sharing.twitter'
                            }
                        },

                        {
                            type: 'yesnoradio',
                            name: "whatsAppShare",

                            props: {
                                labelKey: 'editbreak.steps.sharing.whatsapp'
                            }
                        },

                    ]
                }
            ]
        },
        {
            key: "stepTracking",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,
            showSection: (proxy) => {
                return false;
            },
            props: {
                innerHeader: true,
                getInnerHeader: makeStepSubHeader('editbreak.steps.tracking.headline')
            },

            fields: [
              {
                type: 'hardcodedText',
                props: {
                  text: (proxy) => {return 'Step ID: ' + proxy.currentResource.id}
                }
              },
              {
                type: 'text',
                name: 'reportStepLabel',

                props: {
                  labelKey: 'editbreak.steps.landingPage.reportStepLabel'
                }
              },
              {
                conditionalSection: true,
                name: "hasPageLoadTracking",
                required: true,

                props: {
                    labelKey: 'editbreak.steps.tracking.page_load_tracking'
                },

                fields: [
                    {
                      type: 'textarea',
                      name: 'pageLoadTracking',
                      supportedPlatforms: [
                        'DAILYBREAK',
                        'DEMO',
                        'EMBED'
                      ],
                      props: {
                        placeholderKey: 'editbreak.steps.tracking.page_load_tracking.placeholder'
                      }
                    }
                  ]
              },
              {
                conditionalSection: true,
                name: "hasNextButtonTracking",
                required: true,

                props: {
                    labelKey: 'editbreak.steps.tracking.next_button_tracking'
                },

                fields: [
                    {
                      type: 'textarea',
                      name: 'nextButtonTracking',
                      supportedPlatforms: [
                        'DAILYBREAK',
                        'DEMO',
                        'EMBED'
                      ],
                      props: {
                        placeholderKey: 'editbreak.steps.tracking.next_button_tracking.placeholder'
                      }
                    }
                  ]
              }
            ]
        },
        {
            key: "stepLandingPage",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,
            showSection: (proxy) => {
                // console.log(proxy.currentBaseResource)
                // return (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1)
                return (proxy.currentBaseResource.sponsoredType === "sponsored")
            },

            props: {
                innerHeader: true,
                getInnerHeader: makeStepSubHeader('editbreak.steps.landingPage.headline')
            },

            fields: [
                {
                    type: 'yesnoradio',
                    name: 'publishStep',
                    required: true,

                    props: {
                        labelKey: 'editbreak.steps.landingPage.publishStep'
                    },
                },
                {
                  type: 'text',
                  name: 'internalLabel',

                  props: {
                    labelKey: 'editbreak.steps.landingPage.internalStepLabel'
                  }
                },
                {
                    type: 'contenteditable',
                    name: 'label',

                    props: {
                        labelKey: 'editbreak.steps.landingPage.stepLabel'
                    }
                },
                {
                    type: 'contenteditable',
                    name: 'mobileLabel',

                    props: {
                        labelKey: 'editbreak.steps.landingPage.mobileStepLabel'
                    }
                },
                {
                    type: 'contenteditable',
                    name: 'mapHoverText',

                    props: {
                        labelKey: 'editbreak.steps.landingPage.hoverText'
                    }
                },
                {
                    type: 'image',
                    name: 'mapImageId',
                    idFor: 'mapImage',
                    required: true,
                    props: {
                        labelKey: 'editbreak.steps.landingPage.landingPageStepImage',
                        'imageType': 'mapImage'
                    }
                },
                {
                  type: 'breakStepCheckboxes',
                  showField: (proxy) => (isMultiStepBreak(proxy.currentBaseResource) && proxy.currentBaseResource.sponsoredType === 'sponsored'),
                  name: 'requiredStepCompletions',
                  required: false,
                  supportedPlatforms: [
                    'DAILYBREAK',
                    'DEMO',
                    'EMBED'
                  ],
                  props: {
                    labelKey: 'editbreak.steps.landingPage.required_step_completions',
                    colCount: 1
                  }
                },
                {
                  type: 'breakStepCheckboxes',
                  showField: (proxy) => (isMultiStepBreak(proxy.currentBaseResource) && proxy.currentBaseResource.sponsoredType !== 'sponsored'),
                  name: 'requiredStepCompletions',
                  required: false,
                  supportedPlatforms: [
                    'MASTER',
                    'DAILYBREAK'
                  ],
                  props: {
                    labelKey: 'editbreak.steps.landingPage.required_step_completions',
                    colCount: 1
                  }
                },

            ]
        },
        {
            key: "stepStartPage",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,
            showSection: (proxy) => {
                // console.log(proxy)
                // return (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1)
                return (proxy.currentBaseResource.sponsoredType === "sponsored")

            },

            props: {
                // innerHeader: true,
                // getInnerHeaderOriginal: makeStepSubHeader('editbreak.steps.startScreen.header'),
                getInnerHeader: (props) => {
                    // props is the step
                    console.log(`getInnerHeader`, props)
                    
                    if (props) {
                        if (props.step.hasStartScreen === true) {
                            return makeStepSubHeader('editbreak.steps.startScreen.header', ": On")(props)
                        } else {
                            return makeStepSubHeader('editbreak.steps.startScreen.header', ": Off")(props)
                        }    
                    } else {
                        return makeStepSubHeader('editbreak.steps.startScreen.header')(props)
                    }
                }
            },

            fields: [
                {
                    conditionalSection: true,
                    name: "hasStartScreen",
                    required: true,
                    defaultValue: true,
                    props: {
                        labelKey: 'editbreak.steps.startScreen.has'
                    },

                    fields: [
                        {
                            type: 'contenteditable',
                            name: 'startHeader',
                            required: false,
                            props: {
                                labelKey: 'editbreak.steps.startScreen.headline'
                            }
                        },

                        {
                            type: 'contenteditable',
                            name: 'startBody',
                            required: false,
                            props: {
                                labelKey: 'editbreak.steps.startScreen.body'
                            }
                        },

                        {
                            type: 'text',
                            name: 'startButtonCopy',
                            required: false,
                            props: {
                                labelKey: 'Start Button Copy'
                            }
                        },

                        {
                            type: 'contenteditable',
                            name: 'startFooter',
                            required: false,
                            // showField: (proxy) => (proxy.currentResource.skipStartScreen === 'NO'),
                            props: {
                                labelKey: 'editbreak.steps.startScreen.footer'
                            }
                        },

                        {
                            type: 'image',
                            name: 'startBackgroundImageId',
                            idFor: 'startBackgroundImage',
                            props: {
                                labelKey: 'Background Image',
                                imageType: "custom",
                                helperText: "1920px wide"
                            }
                          },

                          {
                            type: 'image',
                            name: 'mobileStartBackgroundImageId',
                            idFor: 'mobileStartBackgroundImage',
                            props: {
                                labelKey: 'Background Image (mobile)',
                                imageType: 'custom',
                                helperText: "900px wide"
                            }
                          },

                          {
                            type: 'color',
                            name: 'startBackgroundColor',
                            props: {
                                labelKey: 'editbreak.steps.startScreen.backgroundColor'
                            }
                          },

                          {
                            type: 'yesnoradio',
                            name: 'hasStartBackgroundOverlay',
                            required: true,
                            props: {
                              labelKey: 'editbreak.steps.startScreen.backgroundOverlay'
                            }
                          },


                    ]
                }





            ]
        },
        {
            key: "stepBackground",
            subSection: true,
            sectionWrapper: AutoManagedAccordion,
            showSection: (proxy) => {
                // console.log(proxy)
                // return (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1)
                return (proxy.currentBaseResource.sponsoredType === "sponsored")
            },

            props: {
                innerHeader: true,
                getInnerHeader: makeStepSubHeader('editbreak.steps.background')
            },

            fields: [
                {
                    type: 'image',
                    name: 'backgroundImageId',
                    idFor: 'backgroundImage',
                    props: {
                        labelKey: 'Step Background Image (1920px wide)',
                        imageType: 'custom',
                    }
                  },
                  {
                    type: 'image',
                    name: 'mobileBackgroundImageId',
                    idFor: 'mobileBackgroundImage',
                    props: {
                        labelKey: 'Step Background Image - mobile (900px wide)',
                        imageType: 'custom',
                    }
                  },

                  {
                    type: 'color',
                    name: 'backgroundColor',
                    props: {
                        labelKey: 'editbreak.steps.background.backgroundColor'
                    }
                  },

                  {
                    type: 'yesnoradio',
                    name: 'hasBackgroundOverlay',
                    required: true,
                    props: {
                      labelKey: 'editbreak.steps.background.backgroundOverlay'
                    }
                  },

            ]
        },

        {
            type: 'number',
            name: 'rewardForCompleting',
            props: {
                labelKey: 'Points to Award on Step Interaction',
                // helperText: "System does not use this yet but will soon!"
            }
        },

        {
            type: 'currentId',
            name: 'id',
            label: 'Step ID',
            showField: (proxy) => proxy.currentResource.type !== 'BEAKER2',
            // props: {
            //     foo: "bar"
            // }
        },


    ]
};



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksStepsSection.js